const Certificationdata=[
    {
        title:'Front end Projects',
        org:' Dev Challeneges',
        date:'October 21',
        link:'https://devchallenges.io/certificates/QONuzO8VQiRWBZGlN30w',

    },
    {
        title:'HTML For Beginners',
        org:' Sololearn',
        date:' October 21',
        link:'https://www.sololearn.com/Certificate/1014-23318782/jpg',

    },
    {
        title:'CSS Beginners to Advance',
        org:'Udemy',
        date:' October 21',
        link:'https://www.udemy.com/certificate/UC-f883da51-fd6b-4736-97ae-f383536fdc8c/', 

    },
    {
        title:' Javascript For Beginners',
        org:' Sololearn',
        date:' October 21',
        link:'https://www.sololearn.com/certificates/course/en/23318782/1024/landscape/png',

    },
    {
        title:'  Windows Application C#',
        org:' Udemy',
        date:'September 2021',
        link:'https://www.udemy.com/certificate/UC-7f2a1b3f-1928-4f02-883c-e943323c2d35/',

    },
    {
        title:' Python for beginners',
        org:' Udemy',
        date:'Sep 2021',
        link:'https://www.udemy.com/certificate/UC-150a1720-6356-4229-9ced-ebe7fe601c1c/',

    },
    {
        title:'CSS for beginners',
        org:'Sololearn',
        date:' October 2021',
        link:'https://www.sololearn.com/Certificate/1023-23318782/jpg',

    },
    {
        title:' Javascript',
        org:' Udemy',
        date:'March 2022',
        link:"https://udemy-certificate.s3.amazonaws.com/image/UC-fa7d68e6-ea9b-4945-9798-61b7e55558a2.jpg"
 },
 {
    title:'HTML WORKSHOP',
        org:'Geeks for Geeks',
        date:'October 2021',
        link:"cert.pdf"

 }



 

   
]
export default Certificationdata;